"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.MenuTriggerConsumer = exports.useMenuTriggerContext = exports.MenuTriggerProvider = void 0;
var react_1 = __importStar(require("react"));
var button_1 = require("@react-aria/button");
var menu_1 = require("@react-aria/menu");
var menu_2 = require("@react-stately/menu");
var MenuTriggerContext = react_1["default"].createContext({});
function MenuTriggerProvider(_a) {
    var isOpen = _a.isOpen, defaultOpen = _a.defaultOpen, onOpenChange = _a.onOpenChange, children = _a.children;
    // Create state based on the incoming props to manage the open/close
    var state = (0, menu_2.useMenuTriggerState)({ isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange });
    // Get A11y attributes and events for the menu trigger and menu elements
    var ref = react_1["default"].createRef();
    var _b = (0, menu_1.useMenuTrigger)({}, state, ref), menuTriggerProps = _b.menuTriggerProps, menuProps = _b.menuProps;
    // Get A11y attributes and events for the button based on the trigger props from useMenuTrigger
    var buttonProps = (0, button_1.useButton)(menuTriggerProps, ref).buttonProps;
    return (react_1["default"].createElement(MenuTriggerContext.Provider, { value: {
            menuTriggerProps: menuTriggerProps,
            buttonProps: buttonProps,
            menuProps: menuProps,
            menuTriggerState: state,
            buttonRef: ref
        } }, children));
}
exports.MenuTriggerProvider = MenuTriggerProvider;
var useMenuTriggerContext = function () {
    return (0, react_1.useContext)(MenuTriggerContext);
};
exports.useMenuTriggerContext = useMenuTriggerContext;
exports.MenuTriggerConsumer = MenuTriggerContext.Consumer;
MenuTriggerContext.displayName = "MenuTriggerContext";
//# sourceMappingURL=MenuTriggerProvider.js.map